export default __webpack_public_path__ + "static/media/2c.be92d024.png";